<template>
  <modal @close="$emit('close')" back="back">
    <template v-slot:header>{{ title }}</template>

    <div @keyup.esc="$emit('close')" v-focus tabindex="0" class="outline-none">
      <div class="center">
        <div :class="{ busy }" :data-placeholder="placeholder" class="border-bottom p2 placed relative">
          <input v-model="form.search" @focus="focussed = true" @blur="focussed = false" type="search" class="input border-none center">
        </div>
        <ul v-if="filtered" class="list-reset mb4 pb2">
          <li v-for="tag in filtered" :key="tag.item.id" class="py1 h5 mb0">
            <a @click="toggle(tag.item)" :class="{ strong: isSelected(tag.item) }" class="inline-block pointer p1"><highlight-text :item="tag"/></a>
          </li>
          <li v-if="!filtered.length && editable" class="px2 h5 mb0">
            <button @click="addNew" class="btn btn-outline btn-rounded col-12">
              Add new tag '{{ form.search }}'
            </button>
          </li>
        </ul>
        <ul v-if="tags && !filtered" class="list-reset mb4 pb2">
          <li v-for="tag in tags" :key="tag.id" class="py1 h5 mb0">
            <a @click="toggle(tag)" :class="{ strong: isSelected(tag) }" class="inline-block pointer p1">{{ tag.name }}</a>
          </li>
        </ul>
      </div>
      <div @click="$emit('close')" class="absolute bottom-0 left-0 right-0 px2 pb2 bg-white h6 form-actions">
        <button type="button" class="btn btn-rounded white bg-black col-12">SAVE</button>
      </div>
    </div>
  </modal>
</template>

<script>
  import HighlightText from '@/components/HighlightText'
  import Fuse from 'fuse.js'

  export default {
    name: 'TagList',
    props: {
      title: {
        type: String,
        default: 'Add Tags'
      },
      tagType: {
        type: String,
        default: 'folksonomy'
      },
      list: {
        type: Array,
        required: true
      },
      placeholder: String,
      editable: Boolean
    },
    data () {
      return {
        focussed: false,
        form: {
          search: null
        },
        tags: null
      }
    },
    computed: {
      filtered () {
        if (!this.form.search) return

        const options = {
          shouldSort: true,
          includeMatches: true,
          threshold: 0.1,
          location: 0,
          distance: 400,
          maxPatternLength: 32,
          minMatchCharLength: 1,
          keys: ['name']
        }
        let fuse = new Fuse(this.tags, options)
        return fuse.search(this.form.search)
      },
      busy () {
        return this.form.search || this.focussed
      }
    },
    methods: {
      toggle (tag) {
        const i = this.list.findIndex(t => t.id === tag.id)
        if (i > -1) {
          this.list.splice(i, 1)
          return
        }
        this.list.push(tag)
      },
      isSelected ({ id }) {
        return this.list.findIndex(t => t.id === id) > -1
      },

      highlight (match) {
        return match.item.name
      },
      async addNew () {
        if (!this.form.search) return

        const tag = await this.$store.dispatch('addTag', {
          name: this.form.search,
          type: this.tagType
        })

        if (tag) {
          this.tags.unshift(tag)
          this.toggle(tag)
          this.form.search = null
        }
      }
    },
    mounted () {
      this.$store.dispatch('getTags', this.tagType).then(({ data }) => {
        this.tags = data
      })
    },
    components: { HighlightText }
  }
</script>

<style>
  .placed:after {
    content: attr(data-placeholder);
    position: absolute;
    opacity: .3;
    font-size: 10px;
    width: 90%;
    left: 50%;
    transform: translateX(-50%);
    pointer-events: none;
    margin-top: 1.25em;
    line-height: 1.5;
  }

  .placed.busy:after { content: ''; }
</style>
